import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { State } from '@app/core/ngrx/reducers';
import { itinerarySelectors, userSelectors } from '@app/core/ngrx/selectors';
import { ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { ItineraryCustomerInfoComponent } from '../itinerary-customer-info/itinerary-customer-info.component';

import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ItineraryCreateItemsComponent } from '../itinerary-create-items/itinerary-create-items.component';
import { ItineraryCreateItemsMobileComponent } from '../itinerary-create-items-mobile/itinerary-create-items-mobile.component';

@Component({
    selector: 'app-itinerary-create-list',
    templateUrl: './itinerary-create-list.component.html',
    styleUrls: ['./itinerary-create-list.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, FontAwesomeModule, ItineraryCreateItemsComponent, ItineraryCreateItemsMobileComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ItineraryCreateListComponent implements OnInit {
    // list of local storage itinerary items
    itineraryList$ = this.store.select(itinerarySelectors.getItineraryList);

    faQuestionCircle = faQuestionCircle;

    //
    // user store
    USER_ID: string; //
    USER_EMAIL: string; //
    USER_ID$ = this.store.select(userSelectors.getUserID);
    USER_EMAIL$ = this.store.select(userSelectors.getUserEmail);

    trackByIndex = (index: number): number => index;

    constructor(private store: Store<State>, private modalCtrl: ModalController) {}

    ngOnInit() {
        //
        this.USER_ID$.subscribe((userid: string) => (this.USER_ID = userid));
        this.USER_EMAIL$.subscribe((useremail: string) => (this.USER_EMAIL = useremail));

        //
    }

    async whatIsItinerary() {
        const noCartItemsModal = await this.modalCtrl.create({
            component: ItineraryCustomerInfoComponent,
            backdropDismiss: true,
            cssClass: 'itinerary-notify-popup',
        });

        noCartItemsModal.onDidDismiss().then((modalData: any) => {
            if (modalData !== null) {
                if (modalData.data.success === true) {
                    return modalData.data.success;
                } else {
                    return modalData.data.success;
                }
            }
        });

        //
        //
        await noCartItemsModal.present();
        return { success: false };
        //
    }
}
